import React from "react";
import { BrowserRouter } from "react-router-dom";

import { eventListener, TOPICS } from "@origin-digital/event-dispatcher";

import { pageRoutes } from "./consts";
import { Root } from "./root";

declare const __DEV__: boolean;
const __BASEPATH__ = "/my/profile";

const routes = {
  profileAddress: pageRoutes.updateAddress,
  profileDob: pageRoutes.updateDob,
  profileEmail: pageRoutes.updateEmail,
  profileLandline: pageRoutes.updateLandline,
  profileMobile: pageRoutes.updateMobile,
};

type Routes = keyof typeof routes;

if (__DEV__) {
  eventListener.addListener(
    TOPICS.NAV_TO,
    ({ payload: { to } }: { payload: { to: Routes } }) => {
      if (Object.keys(routes).includes(to)) {
        window.location.assign(`${__BASEPATH__}${routes[to].form}`);
      }
    }
  );

  eventListener.addListener(TOPICS.NAV_CLOSE, () => {
    window.location.assign(`${__BASEPATH__}${pageRoutes.base}`);
  });
}

const Application = () => (
  <BrowserRouter basename={__BASEPATH__}>
    <Root />
  </BrowserRouter>
);

const Component = __DEV__
  ? // eslint-disable-next-line
    require("react-hot-loader").hot(module)(Application)
  : Application;

export default Component;
